import { fireUtagEvent } from '@garmin/support-analytics';
import { mapGetters } from 'vuex';
import TranslationsMixin from '../../mixins/translations';

export default {
  name: 'TheIntroHero',
  mixins: [TranslationsMixin],
  computed: {
    ...mapGetters('SSM/', ['systemConfig']),
  },
  methods: {
    onHeadingClick() {
      fireUtagEvent(`${this.systemConfig.mode} Landing,Internal Link,Hero Logo`);
      return this.$router.push({ name: 'landing' });
    },
  },
};
